<ion-content>
  <div class="container">
    <div class="bg-grid">
      <div class="grid-container">
        <div class="grid-content">
            <div style="background-color: #ffff;width: 450px;margin: auto;">
              <div style="padding: 20px 20px;font-family: inherit;line-height: 30px;">
                <mat-icon class="icon">report_problem</mat-icon>
                <p style="font-size:20px;font-weight: lighter;">You do not have permission to access the requested page</p>
              </div>
            </div>
      </div>
    </div>
  </div>
  </div>
</ion-content>